import React from 'react';

const RiskBadge = ({ score, showLabel = true, size = 'md', showTooltip = false }) => {
    const getRiskLevel = (score) => {
        if (score === null || score === undefined) return { level: 'UNKNOWN', color: 'bg-slate-400', textColor: 'text-slate-600' };
        if (score <= 25) return { level: 'LOW', color: 'bg-green-500', textColor: 'text-green-600' };
        if (score <= 50) return { level: 'MEDIUM', color: 'bg-yellow-500', textColor: 'text-yellow-600' };
        if (score <= 75) return { level: 'HIGH', color: 'bg-orange-500', textColor: 'text-orange-600' };
        return { level: 'CRITICAL', color: 'bg-red-500', textColor: 'text-red-600' };
    };

    const { level, color, textColor } = getRiskLevel(score);

    const sizeClasses = {
        sm: 'px-2 py-0.5 text-xs',
        md: 'px-2.5 py-1 text-sm',
        lg: 'px-3 py-1.5 text-base'
    };

    const badge = (
        <span className={`inline-flex items-center ${sizeClasses[size]} font-medium rounded-full ${color} text-white`}>
            {score !== null && score !== undefined ? score : '-'}
            {showLabel && <span className="ml-1">{level}</span>}
        </span>
    );

    if (showTooltip && score !== null && score !== undefined) {
        return (
            <div className="relative group inline-block">
                {badge}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-slate-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
                    <div className="font-semibold mb-1">Risk Score: {score}/100</div>
                    <div className="text-slate-300">
                        {level === 'LOW' && 'Minimal risk - routine monitoring'}
                        {level === 'MEDIUM' && 'Moderate risk - review recommended'}
                        {level === 'HIGH' && 'High risk - immediate attention needed'}
                        {level === 'CRITICAL' && 'Critical risk - urgent action required'}
                    </div>
                    <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1">
                        <div className="w-2 h-2 bg-slate-800 transform rotate-45 -translate-y-1/2"></div>
                    </div>
                </div>
            </div>
        );
    }

    return badge;
};

export default RiskBadge;